import { IConstraintFacilityTruckDetail } from '../../interfaces/iconstraint-facility-truck-detail';
import { Area } from '../area';
import { ConstraintFacilityTruck } from '../constraint-facility-truck';

export class ConstraintFacilityTruckDetailBase {
  ConstraintFacilityTruckDetailId: number;
  ConstraintFacilityTruckId: number;
  AreaId: number | null;
  DailyMax: number | null;
  EffectiveStartDate: Date | null;
  EffectiveFinishDate: Date | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Area?: Area;
  ConstraintFacilityTruck?: ConstraintFacilityTruck;

  constructor(item?: IConstraintFacilityTruckDetail) {
    if (item) {

      this.ConstraintFacilityTruckDetailId = item.ConstraintFacilityTruckDetailId;
      this.ConstraintFacilityTruckId = item.ConstraintFacilityTruckId;
      this.AreaId = item.AreaId;
      this.DailyMax = item.DailyMax;
      this.EffectiveStartDate = item.EffectiveStartDate ? new Date(item.EffectiveStartDate) : null;
      this.EffectiveFinishDate = item.EffectiveFinishDate ? new Date(item.EffectiveFinishDate) : null;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Area = new Area(item.Area);
      this.ConstraintFacilityTruck = new ConstraintFacilityTruck(item.ConstraintFacilityTruck);
    }
  }
}